import { initialPagination, initialState, makeListReducers } from '@/models/utils';
import { filtersConfig } from './utils';
import { bindServices } from '@/services/api';
import { CoreEnums } from '@/utils/domain/constants';
import CoreQueries from '@/utils/input/queries';
import _ from 'lodash';

const namespace = 'delegationConfigurations';
const api = bindServices(namespace);
const { BulkActionType } = CoreEnums;
const fetchRoute = 'delegation/config';

const DelegationConfigurationsModel = {
  namespace,
  state: {
    ...initialState,
    filtersConfig,
    delegationStatus: null,
  },
  effects: {
    *fetchData({ payload }, { call, put, select }) {
      try {
        const pagination = yield select((state) => state[namespace].pagination);
        const pageSize = yield select((state) => state.global.pageSize);
        const res = yield call(api.getAll, {
          route: payload.route ? payload.route : `${fetchRoute}/paged`,
          params: {
            limit: pageSize,
            ...CoreQueries.delegationConfigurations.paged,
            ...pagination,
            ...payload,
          },
          readPriority: true,
        });

        yield put({
          type: 'queryData',
          payload: { ...res, limit: pageSize, page: payload.page },
        });
      } catch (e) {}
    },

    *fetchItem({ payload }, { put }) {
      try {
        yield put({ type: 'success', payload: false });
        yield put({ type: 'queryItem', payload: payload });
      } catch (e) {}
    },

    *fetchCreate({ payload }, { put, call }) {
      try {
        yield put({ type: 'success', payload: { success: false } });
        const res = yield call(api.create, {
          route: payload.route ? payload.route : fetchRoute,
          data: payload.data,
        });
        yield put({
          type: 'success',
          payload: { ...res, success: true },
        });

        yield put({
          type: 'global/showNotificationsGlobal',
          payload: { visible: true, type: 'success' },
        });
      } catch (e) {
        if (e?.message) {
          if (e.validationErrors && _.isEmpty(e.validationErrors[0].field)) {
            _.set(e, 'message', e.validationErrors[0].errorMessages[0]);
          }

          yield put({
            type: 'global/showNotificationsForm',
            payload: { visible: true, type: 'error', message: e.message },
          });

          yield put({
            type: 'errors',
            payload: {
              validationErrors: e.validationErrors || [],
              message: e.message,
            },
          });
        }
      }
    },

    *fetchUpdate({ payload }, { put, call }) {
      try {
        yield put({ type: 'success', payload: { success: false } });
        const res = yield call(api.update, {
          route: payload.route ? payload.route : fetchRoute,
          data: payload.data,
        });
        yield put({
          type: 'success',
          payload: { ...res, success: true },
        });
      } catch (e) {
        if (e?.message) {
          if (e.validationErrors && _.isEmpty(e.validationErrors[0].field)) {
            _.set(e, 'message', e.validationErrors[0].errorMessages[0]);
          }

          yield put({
            type: 'global/showNotificationsForm',
            payload: {
              visible: true,
              type: 'error',
              message: e.message,
            },
          });

          yield put({
            type: 'errors',
            payload: {
              validationErrors: e.validationErrors || [],
              message: e.message,
            },
          });
        }
      }
    },

    *fetchDelete({ payload, onComplete }, { put, call }) {
      try {
        yield put({
          type: 'global/modalConfirm',
          payload: { state: false, id: null },
        });

        yield call(api.remove, {
          route: payload.route ? payload.route : fetchRoute,
          id: payload.id,
        });
        yield put({ type: 'success', payload: { success: true } });
        yield put({
          type: 'global/showNotificationsGlobal',
          payload: { visible: true, type: 'success' },
        });

        onComplete();
      } catch (error) {}
    },

    *setOrderBy({ payload }, { put }) {
      yield put({
        type: 'queryOrderBy',
        payload,
      });
    },

    *changeSuccess({ payload }, { put }) {
      yield put({
        type: 'querySuccess',
        payload,
      });
    },

    *resetState({ payload }, { put }) {
      yield put({
        type: 'queryResetState',
        payload,
      });
    },

    *showForm({ payload }, { put }) {
      yield put({ type: 'queryShowForm', payload });
      if (!_.isNil(payload.id)) {
        yield put({ type: 'editOrDetail', payload });
      }
    },

    *bulkDeleteDelegationConfigs({ payload }, { call, put }) {
      try {
        const { ids } = payload;
        if (!ids || ids.length === 0) return;

        yield call(api.bulkAction, {
          route: 'delegation/config',
          bulkActionType: BulkActionType.Delete,
          ids,
        });

        yield put({
          type: 'global/showNotificationsGlobal',
          payload: { visible: true, type: 'success' },
        });
      } catch (error) {
        if (error.message) {
          yield put({
            type: 'global/showNotificationsGlobal',
            payload: {
              visible: true,
              type: 'error',
              message: error.message,
            },
          });
        }
      }
    },
  },
  reducers: {
    ...makeListReducers({
      initialPagination,
      initialState: {
        ...initialState,
        filtersConfig,
      },
    }),
    saveDelegationStatus(state, { payload }) {
      return {
        ...state,
        delegationStatus: payload?.status || 0,
      };
    },
    queryItem(state, { payload }) {
      return {
        ...state,
        item: payload,
      };
    },
  },
};

export default DelegationConfigurationsModel;
